<div class="l-page-container" >
    <div class="qb-header">
        <div class="module-heading">
            Wallet
        </div>
        <button class="qb-top-panel-content-button primary-button button-hover-effect margin-left-auto" (click)="navigateToCreateWalletConfig()">
            <span *ngIf="buttonType == 'create'">Configure Wallet</span>
            <span *ngIf="buttonType == 'edit'">Edit Wallet Configuration</span> 
        </button>
    </div>
    <div class="card-cont">
        <div class="b-text">Efficiently manage ledgers and topics for a seamless rewards system.</div>
        <div class="c-text">
            Configure and organize your reward structure with customizable ledgers and topics. 
        </div>
    </div>

    <div class="l-preview-container m-h-400">
        <div class="main-white-panel custom-panel col-sm-9">
            <div class="flex">
                <div class="sub-header-1">
                    Ledgers
                </div>
            </div>
            <div class="listing-container">
                <div class="list-column-header-row">
                    <div class="col-header">
                        Ledger Name
                    </div>
                    <div class="col-header">
                        Expiry Days
                    </div>
                    <div class="col-header">
                        Priority
                    </div>
                    <div class="col-header" *ngIf="topicList?.length>0">
                        Topic Name
                    </div>
                </div>
                <div class="main-list">
                    <div class="list-loader-container" *ngIf="isDataLoading">
                        <app-qubriux-loading  [size]="65" [loadingText]="'Fetching your list...'"></app-qubriux-loading>
                    </div>
                    <div *ngIf="!isDataLoading && ledgerList.length == 0" class="empty-list-indicator">
                        No Ledgers found
                    </div>
                    <div *ngIf="!isDataLoading && ledgerList.length > 0">
                        <div *ngFor="let ledger of ledgerList" class="list-item-row">
                            <div class="list-item">
                                <div>{{ledger.ledgerName}}</div>
                            </div>
                            <div class="list-item">
                                <div>{{ledger.expiryDays || 'Never'}}</div>
                            </div>
                            <div class="list-item">
                                <div>{{ledger.priority}}</div>
                            </div>
                            <div class="list-item" *ngIf="topicList?.length>0">
                                <div class="topic">{{ledger.topicName}}</div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    
        <div class="main-white-panel custom-panel col-sm-2 ">
            <div class="flex">
                <div class="sub-header-1">
                    Topics
                </div>
            </div>
            <div class="row g-0" class="topic-list">
                <div *ngIf="topicList.length==0" class="no-topics">
                    No topic added 
                </div>
                <div *ngFor="let topic of topicList;let i=index" class="topic">
                    <div>
                        {{topic.topicName}}
                    </div>
                </div>
            </div> 
        </div>
    </div>
</div>